import React, { Fragment, useState, useEffect, useRef, useMemo, useCallback } from "react";
import QueryService from "../../services/QueryService";
import { useHistory, useLocation } from "react-router";
import SaveModal from "../saveModal/SaveModal";
import CustomLoader from "../customLoader/CustomLoader";
import Loader from "react-loader-spinner";
import AppHeader from "../../Layout/AppHeader";
import AppSidebar from "../../Layout/AppSidebar";
import { useDispatch, useSelector } from "react-redux";
import swal from "sweetalert";
import { Modal } from "reactstrap";
import pageLeft from "../../assets/images/CounselorCurrent/Page/left.png";
import pageLeftHide from "../../assets/images/CounselorCurrent/Page/left-hide.png";
import pageRight from "../../assets/images/CounselorCurrent/Page/right.png";
import pageCenter from "../../assets/images/CounselorCurrent/Page/center.png";
import "./QueryResult.css";
import QueryResultTableCCC from "./QueryResultTableCCC";
import {
  applySelectionChange,
  getSelectionModelForPage,
} from "../../utils/queryResultSelection";

const ShowAlert = ({ number, onCancel, onConfirm }) => (
  <Modal
    centered
    isOpen
    toggle={onCancel}
    className="qr-select-all-modal"
    backdrop="static"
  >
    <div className="qr-select-all-content">
      <button
        type="button"
        className="qr-select-all-close"
        onClick={onCancel}
        aria-label="Close"
      >
        ×
      </button>
      <div className="qr-select-all-icon" aria-hidden="true">
        !
      </div>
      <p className="qr-select-all-title">
        You have selected {Number(number || 0).toLocaleString()} students!
      </p>
      <p className="qr-select-all-subtitle">Are you sure?</p>
      <div className="qr-select-all-actions">
        <button
          type="button"
          className="qr-select-all-btn qr-select-all-btn-cancel"
          onClick={onCancel}
        >
          Cancel
        </button>
        <button
          type="button"
          className="qr-select-all-btn qr-select-all-btn-confirm"
          onClick={onConfirm}
        >
          Yes
        </button>
      </div>
    </div>
  </Modal>
);

const FeatureUnderProgressModal = ({ onClose }) => (
  <Modal
    centered
    isOpen
    toggle={onClose}
    className="qr-select-all-modal"
    backdrop="static"
  >
    <div className="qr-select-all-content">
      <button
        type="button"
        className="qr-select-all-close"
        onClick={onClose}
        aria-label="Close"
      >
        ×
      </button>
      <div className="qr-select-all-icon" aria-hidden="true">
        !
      </div>
      <p className="qr-select-all-title">This feature is under progress</p>
      <p className="qr-select-all-subtitle">
        Group messaging for College Query results will be available soon.
      </p>
      <div className="qr-select-all-actions">
        <button
          type="button"
          className="qr-select-all-btn qr-select-all-btn-confirm"
          onClick={onClose}
        >
          Okay
        </button>
      </div>
    </div>
  </Modal>
);

const QueryResultCCCComponent = () => {
  let history = useHistory();
  let location = useLocation();
  //const resultData = location?.state?.state;
  const [loading, setLoading] = useState(false);
  const [page, setPage] = useState(1);
  const [sortModel, setSortModel] = useState([]);
  const [isModalOpen, setModalOpen] = useState(false);
  const [queryResultData, setQueryResultData] = useState();
  const [tableData, setTableData] = useState([]);
  //const [exportData, setExportData] = useState(location && location.state && location.state.state && location.state.state.export)
  //const [stuPag, setStuPag] = useState(location.state.state.stud_arr);
  //const [dataForAllSelected, setDataForAllSelected] = useState(exportData.shift())
  const [clickedStudent, setClickedStudent] = useState();
  const [openSaveModal, setOpenSaveModal] = useState(false);
  //const [saveQueryData, setSaveQuerydata] = useState(resultData ? resultData.shift() : '')
  const [duplicateQueryData, setDuplicateQueryData] = useState(
    location && location.state ? location.state.duplicateQueryData : ""
  );
  //const [payloadForSaveResult, setPayloadForSaveResult] = useState(location && location.state && location.state.queryResultData ? location.state.queryResultData : '')
  const [from, setFrom] = useState(location?.state?.fromSavedQueriedResult);
  const [paginationCount, setPaginationCount] = useState();
  const [inputValue, setInputValue] = useState("");
  const [selectedRowFromTable, setSelectedRowFromTable] = useState();
  const [openErrorModal, setOpenErrorModal] = useState(false);
  const [selectAll, setSelectAll] = useState(false);

  const [saveSelection, setSaveSelection] = useState([]);
  const savedSelectionRef = useRef([]);
  const shouldRestoreSelectionRef = useRef(false);
  const [loaderForExport, setLoaderForExport] = useState(false);
  const [loaderForSave, setLoaderForSave] = useState(false);
  const [showGroupMessageAlert, setShowGroupMessageAlert] = useState(false);
  const [showFeatureUnderProgress, setShowFeatureUnderProgress] = useState(false);
  const [filteredSaveSelection, setFilteredSaveSelection] = useState([]);
  const [newSelectedIds, setNewSelectedIds] = useState([]);
  const [expandedCells, setExpandedCells] = useState({}); // Track expanded cells

  const [hideSaveResultButton, setHideSaveResultButton] = useState(
    location?.state?.from
  );
  const dispatch = useDispatch();

  let userData = useSelector((state) => state.UserReducer.userObj);

  const selectedAllData = location?.state?.state?.export.filter(
    (item) => item.hasOwnProperty("id") === true
  );

  const navigateToQuery = () => {
    localStorage.removeItem("query");
    history.push("/recruiter/college-query");
  };

  // Map column sort field to backend sort field
  const sortFieldMap = {
    "0": "email",
    "1": "first_name",
    "2": "last_name",
    "3": "ethnicity",
    "4": "gender",
    "5": "overall_gpa",
    "6": "activities",
    "7": "athletics",
    "8": "interests",
    "9": "academics",
    "10": "school_name",
  };

  // useEffect(() => {
  //     if (openSaveModal === false) {
  //         location.state.openSaveModal = false
  //     }
  // }, [openSaveModal])

  const getPageData = (overrideSort) => {
    setLoading(true);
    let queryData = JSON.parse(localStorage.getItem("query"));
    if (queryData) {
      queryData.page = page;
      // attach server-side sort when requested
      const rule = overrideSort || (sortModel && sortModel[0]);
      if (rule && rule.field) {
        const mapped = sortFieldMap[rule.field];
        if (mapped) {
          queryData.sort_by = rule.sort === "desc" ? "desc" : "asc";
          queryData.field = mapped;
        } else {
          // remove sort params if column isn't supported by backend
          delete queryData.sort_by;
          delete queryData.field;
        }
      } else {
        delete queryData.sort_by;
        delete queryData.field;
      }
    }

    QueryService.getCollegeResultPage(queryData)
      .then(async (data) => {
        setQueryResultData(data.data);
        const newArrayOfObj = data.data.student_list.map(
          ({ 11: id, ...rest }) => ({
            id,
            ...rest,
          })
        );
        setTableData(newArrayOfObj);
        setPaginationCount(data.data.total_pages);
        setLoading(false);
      })
      .catch((error) => {
        setLoading(false);
      });
  };

  // useEffect(()=>{
  // },[exportData])

  const convertArrayToTable = async (apiArray, fileName) => {
    const tableRows = apiArray
      .map((obj) => [
        `<tr>
              ${Object.keys(obj)
                .map(
                  (key) =>
                    `<td>${
                      obj[key] === null || key === "id" || obj[key] === ""
                        ? ""
                        : obj[key]
                    }</td>`
                )
                .join("")}
           <tr/>`,
      ])
      .join("");
    const table = `<table>${tableRows}</table>`?.trim();
    const xmlTable = createXMLTable(table, fileName);
    const downloadURL = createFileUrl(xmlTable);
    downloadFile(downloadURL, fileName);
  };

  const createXMLTable = (table, fileName) => {
    const xmlTable = `
              <html xmlns:o="urn:schemas-microsoft-com:office:office xmlns:x="urn:schemas-microsoft-com:office:excel"
             xmlns="http://www.w3.org/TR/REC-html40"
              >
                 <meta http-equiv="content-type" content="application/vnd.ms-excel; charset=UTF-8"/>
                 <head>
                    <xml>
                      <x:ExcelWorkbook>
                          <x:ExcelWorksheets>
                              <x:ExcelWorksheet>
                                  <x:Name>${fileName}</x:Name>
                                  <x:WorksheetOptions><x:DisplayGridlines/></x:WorksheetOptions>
                              </x:ExcelWorksheet>
                          </x:ExcelWorksheets>
                      </x:ExcelWorkbook>
                    </xml>
                 </head>
                 <body>
                   ${table}
                 </body>
              </html> `;
    return xmlTable;
  };

  const createFileUrl = (xmlTable) => {
    const tableBlob = new Blob([xmlTable], {
      type: "application/vnd.ms-excel;base64,",
    });
    const downloadURL = URL.createObjectURL(tableBlob);
    return downloadURL;
  };

  // useEffect(()=>{
  //     downloadFile(csvfile, "Test Download")
  // },[])

  const downloadFile = (downloadURL, fileName) => {
    const downloadLink = document.createElement("a");
    document.body.appendChild(downloadLink);
    downloadLink.download = fileName;
    downloadLink.href = downloadURL;
    downloadLink.click();
  };

  const exportResult = () => {
    setLoaderForExport(true);
    let query = JSON.parse(localStorage.getItem("query"));
    // attach current sort rule to export payload
    if (query) {
      const rule = sortModel && sortModel[0];
      if (rule && rule.field) {
        const mapped = sortFieldMap[rule.field];
        if (mapped) {
          query.sort_by = rule.sort === "desc" ? "desc" : "asc";
          query.field = mapped;
        } else {
          delete query.sort_by;
          delete query.field;
        }
      } else {
        delete query.sort_by;
        delete query.field;
      }
    }
    QueryService.exportResultCCC(query)
      .then((data) => {
        downloadFile(data.data.download, "My File");
        setLoaderForExport(false);
      })
      .catch((error) => {
        setLoaderForExport(false);
      });
  };
  useEffect(() => {
    if (!from) {
      getPageData();
    }
  }, [page]);

  useEffect(() => {
    if (from) {
      setTableData(selectedAllData);
    }
  }, []);

  const onParentContact = ({ row }) => {
    const parentId = row["20"];
    const parentName = row["21"];

    if (parentId) {
      history.push({
        pathname: "/recruiter/parents",
        state: {
          name: parentName || "Parent",
          id: parentId,
        },
        openMessageModal: true,
        fromQueryResult: true,
      });
    } else {
    }
  };

  const isSelectAllActive =
    saveSelection === "selected All" ||
    filteredSaveSelection === "selected All";
  const hasGroupSelection =
    Array.isArray(saveSelection) && saveSelection.length > 0;
  const isGroupMessageDisabled = !hasGroupSelection && !isSelectAllActive;
  const groupMessageSelectedCount = isSelectAllActive
    ? queryResultData?.total_students || tableData.length || 0
    : Array.isArray(saveSelection)
    ? saveSelection.length
    : 0;

  const handleGroupMessageClick = () => {
    if (isGroupMessageDisabled) return;
    setShowGroupMessageAlert(true);
  };

  const handleGroupMessageConfirm = () => {
    setShowGroupMessageAlert(false);
    setShowFeatureUnderProgress(true);
  };

  const handleFeatureUnderProgressClose = () => {
    setShowFeatureUnderProgress(false);
  };

  const toggleModal = () => {
    setModalOpen(!isModalOpen);
  };

  const toggleCellExpansion = (rowId, field) => {
    const key = `${rowId}-${field}`;
    setExpandedCells(prev => ({
      ...prev,
      [key]: !prev[key]
    }));
  };

  const saveStudent = () => {
    setLoaderForSave(true);
    let payload;
    if (saveSelection === "selected All") {
      let detailObj = {};
      let finalObj = newSelectedIds.map((i, index) => {
        detailObj[index] = { school_id: i["15"], student_id: i["16"] };
      });
      payload = {
        is_all: false,
        details: detailObj,
      };
    } else {
      let detailObj = {};
      saveSelection.map((i, index) => {
        detailObj[index] = { school_id: i["15"], student_id: i["16"] };
      });
      payload = {
        is_all: false,
        details: detailObj,
      };
    }
    QueryService.saveStudent(payload)
      .then((res) => {
        setLoaderForSave(false);
        swal("", "Student Saved Successfully", "success");
        setSaveSelection([]);
        savedSelectionRef.current = [];
      })
      .catch((err) => {
        setLoaderForSave(false);
      });
  };

  const saveResult = () => {
    setOpenSaveModal(true);
  };

  const cancel = () => {
    history.push("/recruiter/college-query");
  };

  useEffect(() => {
    if (Array.isArray(saveSelection)) {
      const ids = saveSelection.map((o) => o.id);
      let filtered = saveSelection.filter(
        ({ id }, index) => !ids.includes(id, index + 1)
      );
      setFilteredSaveSelection(filtered);
    } else if (typeof saveSelection === "string") {
      setFilteredSaveSelection("selected All");
    }
  }, [saveSelection]);

  useEffect(() => {
    if (!shouldRestoreSelectionRef.current || loading) return;
    shouldRestoreSelectionRef.current = false;
    setSaveSelection(savedSelectionRef.current);
  }, [tableData, loading]);

  const pageSelectionModel = useMemo(
    () => getSelectionModelForPage(saveSelection, tableData),
    [saveSelection, tableData]
  );

  const pageSelectionSet = useMemo(
    () => new Set(pageSelectionModel),
    [pageSelectionModel]
  );

  const selectedCount = useMemo(() => {
    if (saveSelection === "selected All") {
      return queryResultData?.total_students || tableData.length;
    }
    return Array.isArray(saveSelection) ? saveSelection.length : 0;
  }, [saveSelection, queryResultData, tableData]);

  const sortField = sortModel[0]?.field;
  const sortDirection = sortModel[0]?.sort || "asc";

  const onSelection = useCallback(
    (ids) => {
      const { nextSelection, selectAll } = applySelectionChange({
        ids,
        tableData,
        saveSelection,
        page,
        from,
      });

      setSaveSelection(nextSelection);
      savedSelectionRef.current = nextSelection;
      setSelectAll(selectAll);
    },
    [tableData, saveSelection, page, from]
  );

  const handleRowToggle = useCallback(
    (row, selecting) => {
      const rowId = String(row.id);
      const currentPageIds = [...pageSelectionModel];
      const newPageIds = selecting
        ? currentPageIds.includes(rowId)
          ? currentPageIds
          : [...currentPageIds, rowId]
        : currentPageIds.filter((id) => id !== rowId);
      onSelection(newPageIds);
    },
    [pageSelectionModel, onSelection]
  );

  const handleSelectAllToggle = useCallback(() => {
    const isGlobalAll = saveSelection === "selected All";
    const allOnPageSelected =
      tableData.length > 0 &&
      tableData.every((row) => pageSelectionSet.has(String(row.id)));

    if (isGlobalAll || allOnPageSelected) {
      onSelection([]);
      return;
    }

    if (!from) {
      setSaveSelection("selected All");
      savedSelectionRef.current = "selected All";
      setSelectAll(true);
      return;
    }

    onSelection(tableData.map((row) => String(row.id)));
  }, [saveSelection, tableData, pageSelectionSet, from, onSelection]);

  const handleSort = useCallback(
    (column, direction) => {
      const rule = { field: column.sortField, sort: direction };
      setSortModel([rule]);
      if (!from) {
        if (page !== 1) {
          setPage(1);
        }
        getPageData(rule);
      }
    },
    [from, page]
  );

  return (
    <Fragment>
      <AppHeader />
      <Modal centered={true} toggle={toggleModal} isOpen={isModalOpen}>
        <div style={{ padding: '20px' }}>
          <h5>Query Result Details</h5>
          <p>Additional functionality can be added here if needed.</p>
        </div>
      </Modal>
      <div className="app-main">
        <AppSidebar />
        <div className="app-main__outer">
      <div className="query-result-container">
        <div className="inner-query-result-container">
          <div className="view-result qr-header">
            <div>
              <button
                type="button"
                className="qr-back-btn"
                aria-label="Back"
                onClick={() => history.goBack()}
              >
                <img
                  src={require("../../assets/images/queryResult/back.png")}
                  alt="Back"
                  className="qr-back-img"
                />
              </button>
              <span className="qr-title-text" style={{ marginLeft: "10px" }}>Query Results</span>
              <span className="qr-title-divider"> | </span>
              <span className="qr-title-count">{`
                ${
                  queryResultData
                    ? queryResultData?.total_students
                    : from
                    ? tableData.length
                    : 0
                } Students Found`}</span>
            </div>
          </div>
          <div className="qr-subtitle-row">
            <p
              style={{ color: "#333333", opacity: "0.8", margin: 0 }}
              className="bold"
            >{`You are viewing ${
              tableData ? tableData?.length : 0
            } Student out of ${
              queryResultData ? queryResultData?.total_students : 0
            } Results`}</p>
          </div>
          {loading ? (
            <CustomLoader />
          ) : (
            <div
              className={`qr-table-shell ${
                paginationCount && paginationCount > 1
                  ? "table-container"
                  : "table-container-less"
              }`}
            >
              <QueryResultTableCCC
                tableData={tableData}
                saveSelection={saveSelection}
                pageSelectionSet={pageSelectionSet}
                onRowToggle={handleRowToggle}
                onSelectAllToggle={handleSelectAllToggle}
                sortField={sortField}
                sortDirection={sortDirection}
                onSort={handleSort}
                expandedCells={expandedCells}
                toggleCellExpansion={toggleCellExpansion}
                onParentContact={onParentContact}
                selectedCount={selectedCount}
              />
            </div>
          )}

          <div className="qr-footer-topline" />
          <div className="result-button-container">
            {/* {userData.is_premium === true ? (
              <button
                style={{ justifyContent: "center" }}
                className="qr-footer-btn qr-footer-btn-primary"
                onClick={() =>
                  saveSelection.length > 0 ? saveStudent() : ""
                }
              >
                <img src={require("../../assets/images/queryResult/save.png")} alt="" className="btn-icon" />
                Save to My Students
              </button>
            ) : (
              <button
                style={{ justifyContent: "center" }}
                className="qr-footer-btn qr-footer-btn-primary"
                onClick={toggleModal}
              >
                <img src={require("../../assets/images/queryResult/save.png")} alt="" className="btn-icon" />
                Save to My Students
              </button>
            )} */}
            <button
              onClick={handleGroupMessageClick}
              className={`qr-footer-btn qr-footer-btn-secondary ${isGroupMessageDisabled ? "disabled" : ""}`}
              style={{
                opacity: isGroupMessageDisabled ? 0.5 : 1,
                cursor: isGroupMessageDisabled ? "not-allowed" : "pointer",
              }}
              disabled={isGroupMessageDisabled}
            >
              <img src={require("../../assets/images/queryResult/group.png")} alt="" className="btn-icon" />
              Group Message
            </button>
            <button
              onClick={
                from
                  ? () => convertArrayToTable(selectedAllData, "My File")
                  : () => exportResult()
              }
              style={{ justifyContent: "center" }}
              className="qr-footer-btn qr-footer-btn-secondary flex"
            >
              <img src={require("../../assets/images/queryResult/export.png")} alt="" className="btn-icon" />
              Export Results
              {loaderForExport && (
                <span>
                  <Loader
                    type="TailSpin"
                    color="#E36221"
                    height={20}
                    width={20}
                  />
                </span>
              )}
            </button>
            <button
              onClick={() => cancel()}
              className="qr-footer-btn qr-footer-btn-secondary"
            >
              <img src={require("../../assets/images/queryResult/close.png")} alt="" className="btn-icon" />
              Cancel
            </button>
          </div>
        </div>
          {(() => {
            const totalPages = from ? Math.ceil(tableData.length / 20) : paginationCount;
            return paginationCount && totalPages > 1 ? (
              <div className="qr-pagination-outside">
                <div className="custom-pagination">
                  <button
                    type="button"
                    aria-label="Prev"
                    className={`pagination-btn ${page === 1 ? "disabled" : ""}`}
                    onClick={() => {
                      if (page > 1) {
                        savedSelectionRef.current = saveSelection;
                        shouldRestoreSelectionRef.current = true;
                        setPage(page - 1);
                      }
                    }}
                  >
                    <img
                      src={page === 1 ? pageLeftHide : pageLeft}
                      alt="Prev"
                      className="pagination-img"
                    />
                  </button>
                  <div className="pagination-center">
                    <img src={pageCenter} alt="Page" className="pagination-img" />
                    <span className="pagination-number" style={{color:'white'}}>{page}</span>
                  </div>
                  <button
                    type="button"
                    aria-label="Next"
                    className={`pagination-btn ${page >= totalPages ? "disabled" : ""}`}
                    onClick={() => {
                      if (page < totalPages) {
                        savedSelectionRef.current = saveSelection;
                        shouldRestoreSelectionRef.current = true;
                        setPage(page + 1);
                      }
                    }}
                  >
                    <img src={pageRight} alt="Next" className="pagination-img" />
                  </button>
                </div>
              </div>
            ) : null;
          })()}
      </div>
      {showGroupMessageAlert && (
        <ShowAlert
          number={groupMessageSelectedCount}
          onConfirm={handleGroupMessageConfirm}
          onCancel={() => {
            setShowGroupMessageAlert(false);
          }}
        />
      )}
      {showFeatureUnderProgress && (
        <FeatureUnderProgressModal onClose={handleFeatureUnderProgressClose} />
      )}
      {openSaveModal && (
        <SaveModal
          openSaveModal={openSaveModal}
          setOpenSaveModal={setOpenSaveModal}
          //duplicateQueryData={duplicateQueryData}
          //saveQueryData={selectedAllData}
          inputValueForSave={inputValue}
          setInputValueForSave={setInputValue}
          openErrorModal={true}
          setOpenErrorModal={setOpenErrorModal}
          //saveFromSavedResult={from ? true : false}
          // payloadForSaveResult={payloadForSaveResult}
        />
      )}
      {/* {
                openErrorModal && <ErrorModal
                    openErrorModal={openErrorModal}
                    setOpenErrorModal={setOpenErrorModal}
                    text="Query"
                />
            } */}
   </div>
      </div>
    </Fragment>
  );
};
export default QueryResultCCCComponent;